export const breakpoints = {
  xs: 0,
  sm: 480,
  md: 641,
  lg: 1081,
  xl: 1441,
};
